import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import {environment} from '../../../../environments/environment';
import {CookieService} from 'ngx-cookie';
declare var DDP_ENV: any;
@Injectable({
  providedIn: 'root'
})
export class ClientinventoryServiceService {

  readonly baseURL = DDP_ENV.inventoryUrl;

  constructor(private _http: Http, private cookieService: CookieService) {}

  getClientInventory(page, status, size, regExp, clientId) {
    console.log('Inside get client inventory');
    return this._http.get(this.baseURL + '/clientinventory/client/' + clientId + '?page=' + page + '&size=' + size + '&status=' + status + '&regexPattern=' + regExp, this.buildHeaders());
  }

  returnPackage(updatePackageRequest) {
    console.log('Inside returnPackage');
    return this._http.put(this.baseURL + '/clientinventory/returnpackage' , updatePackageRequest, this.buildHeaders());
  }

  markPackageAvailable(updatePackageRequest) {
      console.log('Inside mark package available');
      return this._http.put(this.baseURL + '/clientinventory/'+updatePackageRequest.serialNumber+'/markavailable',updatePackageRequest,  this.buildHeaders());
  }

  /* Construct a common header */
  private buildHeaders(): any {
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers });
  }
}
